'use client';
import Image from "next/image";
import { Fragment, MouseEvent, MouseEventHandler, useEffect, useRef, useState } from "react";
import Typography from "../common/typography";

type BeforeAndAfterComparatorProps = {
  beforeImage: string;
  afterImage: string;
};

export function BeforeAndAfterComparator() {
  const afterRef = useRef<HTMLImageElement>(null);
  const beforeRef = useRef<HTMLImageElement>(null)
  const sliderRef = useRef<HTMLDivElement>(null);
  const imageRef = useRef<HTMLDivElement>(null);
  const [defaultState, setDefaultState] = useState(true)



  useEffect(() => {
    if (afterRef.current) {
      afterRef.current.style.clipPath = `inset(0 ${77}% 0 0)`;
    } 
  }, [afterRef])

  const handleSliderMove = (clientX: number) => {
    setDefaultState(false)
    if (!sliderRef.current || !imageRef.current) return;
    const parentBox = imageRef.current.getBoundingClientRect();
    const imgBox = afterRef.current?.getBoundingClientRect() ?? parentBox;
    const clampedClientX = Math.min(imgBox.right, Math.max(imgBox.left, clientX));
    const sliderWidth = sliderRef.current.getBoundingClientRect().width || sliderRef.current.offsetWidth || 0;
    let leftPx = clampedClientX - parentBox.left - sliderWidth / 2;
    leftPx = Math.max(0, Math.min(parentBox.width - sliderWidth, leftPx));
    sliderRef.current.style.left = `${leftPx}px`;
    const pct = imgBox.width > 0 ? ((clampedClientX - imgBox.left) / imgBox.width) * 100 : 0;
    if (afterRef.current) {
      afterRef.current.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
    }
  }
    const resetToDefault = () => {
    setDefaultState(true)
    if (sliderRef.current && imageRef.current && afterRef.current) {
      const parentBox = imageRef.current.getBoundingClientRect();
      const sliderWidth = sliderRef.current.getBoundingClientRect().width || sliderRef.current.offsetWidth || 0;
      const defaultPct = 23; // 77% clip = 23% visible
      const leftPx = (parentBox.width * (defaultPct / 100)) - (sliderWidth / 2);
      sliderRef.current.style.left = `${leftPx}px`;
      afterRef.current.style.clipPath = `inset(0 ${77}% 0 0)`;
    }
  };

  return (
    <div
      className="relative w-full max-w-[500px] sm:mx-auto mx-6 aspect-square select-none"
      ref={imageRef}
      onTouchMove={(e) => {
        if (e.touches.length) {
          handleSliderMove(e.touches[0].clientX)
        }
      }}
      onMouseMove={(e) => handleSliderMove(e.clientX)}
      onTouchCancel={resetToDefault}
      onMouseLeave={resetToDefault}
    >
      <figure className="absolute inset-0">
        <Image alt="Tire before pandahub" quality={80} src={"ab50f15a-aeed-416c-ab4a-c53ac47f888f.png"} fill className="object-cover" ref={beforeRef} />
      </figure>
      <figure className="absolute inset-0">
        <Image alt="Tire after pandahub" quality={90} src={"02b14216-6f29-4024-89f8-f11da9b881c5.png"} fill className="object-cover" ref={afterRef} />
      </figure>
      <div className="absolute w-2 h-full z-30 bg-white right-3/4 -translate-x-1/2" ref={sliderRef}>
          {/* left/right chevron for slider */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16 gap-4 rounded-full flex items-center justify-center" >
          
          <svg className="rotate-180" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 12" width="6" height="12"><path className="shadow-default" fill="white" fill-rule="evenodd" d="m0 0 6 6-6 6z"></path></svg>
          
          <svg className="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 12" width="6" height="12"><path className="shadow-default" fill="white" fill-rule="evenodd" d="m0 0 6 6-6 6z"></path></svg>

        </div>
      </div>



          {defaultState && (
            <>
            <span className="bg-black rounded-sm px-2 py-1 z-30 w-fit absolute bottom-0 right-3/6 sm:left-1/12 transform -translate-x-1/2 -translate-y-1/2">
              <Typography size="unresponsiveBody2" weight={300} color="white">Before Panda</Typography>
            </span>

            <span className="bg-black rounded-sm px-2 py-1 absolute bottom-0 -right-1/12 transform -translate-x-1/2 -translate-y-1/2">
              <Typography size="unresponsiveBody2" weight={300} color="white">After Panda</Typography>
            </span>
            </>
          )}

    </div>
  )
}